import React, { Component } from "react";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Icon from "@material-ui/core/Icon";
import { Link } from "react-router-dom";
import MeetingDate from "../MeetingDate";
import MeetingType from "../MeetingType";

const classes = {
	vCenter: {
		display: "flex",
		alignItems: "center"
	},
	textField: {
		width: "100%"
	},
	card: { padding: "20px" }
};

export default class settings extends Component {
	state = {
		title: "Test Meeting",
		venue: "CSE Building",
		type: "support",
		details: "test meeting details"
	};

	handleChange = () => {
		console.log("wow");
	};
	render() {
		return (
			<form noValidate autoComplete="off" style={{ width: this.props.width }}>
				<Grid
					container
					style={{
						alignItems: "center"
					}}
				>
					<Grid xs={4}>
						<p style={{ marginTop: 15 }}>Meeting Title</p>
					</Grid>
					<Grid xs={8}>
						<TextField
							id="outlined-bare"
							style={classes.textField}
							placeholder="Enter Meeting Title"
							variant="outlined"
							inputProps={{ "aria-label": "bare" }}
							value={this.state.title}
						/>
					</Grid>
				</Grid>
				<Grid
					container
					style={{
						alignItems: "center",
						marginTop: 10
					}}
				>
					<Grid xs={4}>
						<p style={{ marginTop: 15 }}>Meeting Type</p>
					</Grid>
					<Grid xs={8}>
						<MeetingType type={this.state.type} />
					</Grid>
				</Grid>
				<Grid
					container
					style={{
						alignItems: "center",
						marginTop: 10
					}}
				>
					<Grid xs={4}>
						<p style={{ marginTop: 15 }}>Meeting Venue</p>
					</Grid>
					<Grid xs={8}>
						<TextField
							id="outlined-bare"
							style={classes.textField}
							placeholder="Enter Meeting Title"
							variant="outlined"
							value={this.state.venue}
							inputProps={{ "aria-label": "bare" }}
						/>
					</Grid>
				</Grid>
				<Grid
					container
					style={{
						alignItems: "center",
						marginTop: 10
					}}
				>
					<Grid xs={4}>
						<p>Meeting Date</p>
					</Grid>
					<Grid xs={8}>
						<MeetingDate />
					</Grid>
				</Grid>
				<Grid
					container
					style={{
						alignItems: "center",
						marginTop: 10
					}}
				>
					<Grid xs={4}>
						<p>Meeting Details</p>
					</Grid>
					<Grid xs={8}>
						<TextField
							id="outlined-multiline-static"
							multiline
							rows="4"
							className={classes.textField}
							variant="outlined"
							style={{ width: "100%" }}
							placeholder="Enter Meeting Details"
							value={this.state.details}
						/>
					</Grid>
				</Grid>
			</form>
		);
	}
}
